module.exports = __webpack_public_path__ + "static/media/NDVIBlue.5e2fa55e.png";